import {
  DialogTitle as DialogTitleMUI,
  Dialog as DialogMUI,
  DialogActions as DialogActionsMUI,
  DialogContent as DialogContentMUI,
  Button,
  styled,
} from '@mui/material';

import { theme } from 'styles';

export const Dialog = styled(DialogMUI)(() => ({
  '.MuiDialog-paper': {
    maxWidth: '480px',
    width: '100%',
    padding: '32px 32px 28px',
    background: theme.palette.white.main,
    borderRadius: '12px',
    textAlign: 'center',
    boxShadow: '0px 8px 32px rgba(0, 0, 0, 0.12)',
  },

  '.MuiBackdrop-root': {
    background: 'rgba(0, 0, 0, 0.2)',
    backdropFilter: 'blur(4px)',
  },
}));

export const IconWrapper = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'center',
  marginBottom: '16px',
}));

export const DialogTitle = styled(DialogTitleMUI)(() => ({
  padding: 0,
  fontWeight: 700,
  fontSize: '18px',
  lineHeight: '26px',
  color: theme.palette.primary.main,
  marginBottom: '8px',
  textAlign: 'center',
}));

export const SubTitle = styled('p')(() => ({
  margin: '0 0 24px',
  fontSize: '14px',
  lineHeight: '20px',
  color: theme.palette.primary.grey,
  textAlign: 'center',
}));

export const DialogContent = styled(DialogContentMUI)<{ isContentOverflow?: boolean }>`
  padding: 0;
  overflow-y: ${({ isContentOverflow }) => (isContentOverflow ? 'visible' : 'auto')};
`;

export const DialogActions = styled(DialogActionsMUI)(() => ({
  padding: 0,
  display: 'flex',
  justifyContent: 'center',
  gap: '12px',
  marginTop: '8px',
}));

export const CancelButton = styled(Button)(() => ({
  flex: 1,
  textTransform: 'none',
  fontWeight: 500,
  fontSize: '14px',
  borderRadius: '8px',
  padding: '10px 20px',
  color: theme.palette.secondary.dark,
  border: `1px solid ${theme.palette.primary.grey}`,
  backgroundColor: theme.palette.white.main,
}));

export const SubmitButton = styled(Button)(() => ({
  flex: 1,
  textTransform: 'none',
  fontWeight: 600,
  fontSize: '14px',
  borderRadius: '8px',
  padding: '10px 20px',
  color: theme.palette.white.main,
  backgroundColor: theme.palette.info.dark,
  border: 'none',
}));

export const CloseButton = styled(Button)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-start',
  textTransform: 'none',
  fontSize: '24px',
  lineHeight: '24px',
  color: theme.palette.primary.main,

  '.MuiButton-startIcon': {
    fontSize: '2rem',
    marginRight: '24px',
  },

  '.MuiSvgIcon-root': {
    width: '1.5em',
    height: '1.5em',
  },
}));
